// extracted by mini-css-extract-plugin
export default {"card":"styles-module--card--c111d","imageInner":"styles-module--imageInner--1ae8f","titleWrap":"styles-module--titleWrap--11d6a","cardTitle":"styles-module--cardTitle--04563"};